<script setup lang="ts">
import type { SectionNodePlanning } from "@/domains/v4b/site-programming-range/site-programming-range.types";

import { computed } from "vue";

import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { useTypedIntl } from "@/locales/typed-intl";
import { countAllLeafDescendants } from "@/utils/site-section/site-section-utils";

const props = defineProps<{
  sectionChildren: SectionNodePlanning;
}>();

const { t, k } = useTypedIntl();

const countAllLeafSectionDescendants = computed<number>(() => {
  return countAllLeafDescendants(props.sectionChildren);
});
</script>

<template>
  <div
    class="rounded-lg h-[48px] flex items-center justify-center gap-2 w-full bg-gray-100 text-text-secondary"
    :data-test-id="DATA_TEST_IDS.components.sectionChildrenProgrammingRangesCountCell.component"
  >
    <small
      class="font-semibold"
      :data-test-id="
        DATA_TEST_IDS.components.sectionChildrenProgrammingRangesCountCell.countLeafDescendantsProgrammingRangesText
      "
      >{{
        t(
          k.global.count.section({
            count: countAllLeafSectionDescendants,
          }),
        )
      }}</small
    >
  </div>
</template>
